<template>
    <div class="price-slider">
        <div class="slider-container">
            <!-- Трек -->
            <div class="track" ref="track">
                <div class="track-filled" :style="{ width: fillWidth + '%' }"></div>

                <div v-for="(mark, i) in marks" :key="i"
                     class="mark"
                     :style="{ left: mark.position + '%' }">
                    <div class="mark-line"></div>
                    <div class="mark-label">{{ mark.label }}</div>
                </div>
            </div>

            <!-- Ползунок -->
            <div
                class="thumb"
                :style="{ left: thumbPosition + '%' }"
                @mousedown="startDrag"
                @touchstart="startDrag">
                <div class="bubble">
                    {{ formatValue(value) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home-possible-earnings-range',
    props: {
        value: { type: Number, default: 10000000 },
        min: { type: Number, default: 100000 },
        max: { type: Number, default: 100000000 },
    },
    data() {
        return { isDragging: false };
    },
    computed: {
        thumbPosition() {
            return ((this.value - this.min) / (this.max - this.min)) * 100;
        },
        fillWidth() {
            return this.thumbPosition;
        },
        marks() {
            const marksData = [
                { value: 100000, label: '100 тыс.' },
                { value: 500000, label: '500 тыс.' },
                { value: 1000000, label: '1 млн.' },
                { value: 2000000, label: '2 млн.' },
                { value: 5000000, label: '5 млн.' },
                { value: 20000000, label: '20 млн.' },
                { value: 50000000, label: '50 млн.' },
                { value: 100000000, label: '100 млн.' },
            ];

            return marksData.map(mark => ({
                ...mark,
                position: ((mark.value - this.min) / (this.max - this.min)) * 100,
            }));
        },
    },
    methods: {
        formatValue(val) {
            if (val >= 1000000) {
                return (val / 1000000).toFixed(val % 1000000 === 0 ? 0 : 1) + ' млн. руб.';
            }
            return (val / 1000).toFixed(0) + ' тыс. руб.';
        },

        startDrag(e) {
            this.isDragging = true;
            this.moveSlider(e);
            document.addEventListener('mousemove', this.moveSlider);
            document.addEventListener('mouseup', this.stopDrag);
            document.addEventListener('touchmove', this.moveSlider, { passive: false });
            document.addEventListener('touchend', this.stopDrag);
        },

        stopDrag() {
            this.isDragging = false;
            document.removeEventListener('mousemove', this.moveSlider);
            document.removeEventListener('mouseup', this.stopDrag);
            document.removeEventListener('touchmove', this.moveSlider);
            document.removeEventListener('touchend', this.stopDrag);
        },

        moveSlider(e) {
            if (!this.isDragging) return;
            const track = this.$refs.track;
            const rect = track.getBoundingClientRect();
            const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;

            let percent = (clientX - rect.left) / rect.width;
            percent = Math.max(0, Math.min(1, percent));

            const newValue = Math.round(this.min + percent * (this.max - this.min));
            this.$emit('input', newValue);
        },
    },
};
</script>

<style lang="less" scoped>
@primary: #6b46c1;
@primary-light: #9f7aea;
@track-bg: #e0d9f7;
@text-color: #4a5568;

.price-slider {
    padding: 40px 20px 60px;
    max-width: 800px;
    margin: 0 auto;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.slider-container {
    position: relative;
    height: 60px;
}

.track {
    position: absolute;
    top: 28px;
    left: 0;
    right: 0;
    height: 6px;
    background: linear-gradient(to right, @primary 0%, @primary 60%, @track-bg 60%, @track-bg 100%);
    border-radius: 9999px;
    cursor: pointer;

    .track-filled {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background: @primary;
        border-radius: 9999px;
    }

    .mark {
        position: absolute;
        top: 28px;
        transform: translateX(-50%);

        .mark-line {
            width: 2px;
            height: 12px;
            background: @primary-light;
            margin: 0 auto;
        }

        .mark-label {
            margin-top: 8px;
            font-size: 12px;
            color: @text-color;
            white-space: nowrap;
        }
    }
}

.thumb {
    position: absolute;
    top: 22px;
    width: 28px;
    height: 28px;
    background: white;
    border: 4px solid @primary;
    border-radius: 50%;
    cursor: grab;
    transform: translateX(-50%);
    box-shadow: 0 4px 12px rgba(107, 70, 193, 0.3);
    z-index: 10;
    transition: transform 0.1s;

    &:active {
        cursor: grabbing;
        transform: translateX(-50%) scale(1.1);
    }

    .bubble {
        position: absolute;
        top: -52px;
        left: 50%;
        transform: translateX(-50%);
        background: @primary;
        color: white;
        padding: 6px 14px;
        border-radius: 9999px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

        &:after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -6px;
            border: 6px solid transparent;
            border-top-color: @primary;
        }
    }
}
</style>
